import { DocumentState } from '@evorait/pace-forms';
import { Address, ConfigConstants, Notification, NOTIFICATION_STATUS_CODE } from '@evorait/pace-core';
import moment from 'moment';

export const mapDocBoxToNotificationData = (frontId: string, rawData: DocumentState | undefined): Notification => {
    return {
        identifier: { frontId: frontId, qmNum: rawData?.notification ?? '', maNum: '' },
        languageId: rawData?.language ?? '',
        notificationType: rawData?.notificationType ?? ConfigConstants.NotificationTypes.Unknown,
        functionalLocation: rawData?.funcLoc ?? '',
        backendStatus: {
            statusCode: NOTIFICATION_STATUS_CODE.CRM,
            startTime: moment().toISOString(),
            endTime: moment().toISOString(),
        },
        updatedStatus: {
            statusCode: NOTIFICATION_STATUS_CODE.CRM,
            startTime: moment().toISOString(),
            endTime: moment().toISOString(),
        },
        address: {} as Address,
        emailSet: [],
        equipmentSet: [
            {
                equnr: rawData?.equipment ?? '',
                tidnr: '',
                matnr: rawData?.material ?? '',
                sernr: rawData?.serialNo ?? '',
                equiShortDesc: rawData?.description ?? '',
                division: '',
                mainEquipmentIndicator: '',
            },
        ],
    };
};
